export const BRAND_DOMAINS = {
  WMG: {
    dev: 'dev.wmg1.dev',
    staging: 'staging.wmg1.dev',
    prod: 'wmg1.com',
  },
  ADA: {
    dev: 'dev.partners.ada-music.com',
    staging: 'staging.partners.ada-music.com',
    prod: 'partners.ada-music.com',
  },
} as const;

export const WMG_DOMAINS = Object.values(BRAND_DOMAINS.WMG);
export const ADA_DOMAINS = Object.values(BRAND_DOMAINS.ADA);
